export enum PlatformPermission {
  'Admin' = 'Admin',
  'Support' = 'Support',
  'ViewUser' = 'ViewUser',
  'DeleteUser' = 'DeleteUser',
  'UpdateUserDetails' = 'UpdateUserDetails',
  'ManageLoanApplication' = 'ManageLoanApplication',
  'ManageLoan' = 'ManageLoan',
  'ManageBankConnections' = 'ManageBankConnections',
  'ManageKYC' = 'ManageKYC',
  'DeveloperTools' = 'DeveloperTools',
}

const validPermissions = new Set<string>(Object.values(PlatformPermission))

// Default role applied when appRole is missing or empty
export const DEFAULT_PERMISSIONS: PlatformPermission[] = [PlatformPermission.ViewUser]

export function getUserPermissions(appRole: string | string[] | undefined): PlatformPermission[] {
  if (!appRole) return [...DEFAULT_PERMISSIONS]

  const permissionSet = new Set<PlatformPermission>()

  const rawList = Array.isArray(appRole) ? appRole : appRole.split(',')

  for (const raw of rawList) {
    const perm = raw.trim()
    if (validPermissions.has(perm)) {
      permissionSet.add(perm as PlatformPermission)
    }
  }

  // If nothing valid was parsed (e.g. whitespace-only string, unknown roles),
  // still fall back to the default role rather than leaving the user with none.
  if (permissionSet.size === 0) return [...DEFAULT_PERMISSIONS]

  return Array.from(permissionSet)
}
